import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule,
} from 'vuex-module-decorators';

import store from '@/store';
import {
  userAddSigStatements,
  statementXmlBase64,
  saveAdditionalSignature,
} from '@/api/statementsJoint';
import { IPagination, IStatementShortInfo } from '@/utils/types';
import { ErrorAlertModule } from '@/store/modules/errors';
import { IRequestRefusalSend } from '@/types/alternativeServices';
import { errorHandler } from '@/utils/common';

export interface IStatementJointState {
  list: IStatementShortInfo[];
  totalCount: number;
  pagination: {
    pageNumber: number;
    pageSize: number;
  };
}

@Module({ dynamic: true, store, name: 'statementsJoint', namespaced: true })
class StatementsJoint extends VuexModule implements IStatementJointState {
  list = [];
  totalCount = 0;
  pagination = {
    pageNumber: 0,
    pageSize: 15,
  };

  @Mutation
  setStatementsList(data: any) {
    this.list = data;
  }

  @Mutation
  setTotalCount(value: number) {
    this.totalCount = value;
  }

  @Mutation
  setPagination(payload: any) {
    this.pagination = payload;
  }

  @Mutation
  setPageSize(payload: number) {
    this.pagination.pageSize = payload;
  }

  @Mutation
  setPageNumber(payload: number) {
    this.pagination.pageNumber = payload;
  }

  @Action
  changePagination(payload: IPagination) {
    this.setPagination(payload);
  }

  @Action
  changePageSize(payload: number) {
    this.setPageSize(payload);
  }

  @Action
  changePageNumber(payload: number) {
    this.setPageNumber(payload);
  }

  @Action({ rawError: true })
  async loadUserAddSigStatements() {
    ErrorAlertModule.setErrorAlert('');
    try {
      const { count, items } = await userAddSigStatements(
        this.pagination.pageNumber,
        this.pagination.pageSize
      );
      this.setStatementsList(items);
      this.setTotalCount(count);
    } catch (error) {
      errorHandler(error)
    }
  }

  @Action({ rawError: true })
  async statementXmlBase64(id: string) {
    ErrorAlertModule.setErrorAlert('');
    try {
      return await statementXmlBase64(id);
    } catch (error) {
      errorHandler(error);
      throw error;
    }
  }

  @Action({ rawError: true })
  async saveAdditionalSignature(data: IRequestRefusalSend) {
    ErrorAlertModule.setErrorAlert('');
    try {
      await saveAdditionalSignature(data);
    } catch (error) {
      errorHandler(error);

      throw error;
    }
  }
}

export const StatementsJointModule = getModule(StatementsJoint);
